import { useState } from "react";
import Layout from "../../../custom/Layout";
import { Nav } from "reactstrap";
import CustomNavItem from "../../../custom/CustomNavItem";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../custom/CustomTabPane";
import CreateTransferExport from "./CreateTransferExport";
import Log from "./Log";

export type Tab = 'CREATE' | 'LOG';

export default function TransfersExport() {

    const [activeTab, setActiveTab] = useState<Tab>('CREATE');
    const toggleTab = (tab: Tab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Truck Buildup"
                    tabId="CREATE"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Log"
                    tabId="LOG"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'CREATE'}>
                    <CreateTransferExport />
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'LOG'}>
                    <Log />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}

